export default __webpack_public_path__ + "static/media/hand-to-hand.676ed2f1.svg";